import type {NodeEnvironment} from '#types/environment.js';

export const getCurrentEnv = (): NodeEnvironment => {
  if (typeof process !== 'undefined' && process.env.NODE_ENV) {
    return process.env.NODE_ENV === 'production' ? 'production' : 'development';
  }

  return 'development';
};

export const ENV_SPECIFIC_BASE_URLS: Record<NodeEnvironment, string> = {
  development: 'http://localhost:8080',
  production: '', // Empty means use window.location in production
};

export const getEnvBaseUrl = (): string => {
  const env = getCurrentEnv();
  return ENV_SPECIFIC_BASE_URLS[env];
};
